import type { AppEnvironment } from '@ochal/config';
import type { FeatureFlagDefinition } from '@ochal/module-sdk/contracts';
export function getFeatureFlags(env: AppEnvironment): FeatureFlagDefinition[] { return [
  {id:'module-management.enabled',state:'enabled',owner:'module-management',description:'System module runtime inspection'},
  {id:'users',state:env.VITE_ENABLE_USERS?'enabled':'disabled'},
  {id:'roles',state:env.VITE_ENABLE_ROLES?'enabled':'disabled'},
  {id:'audit',state:env.VITE_ENABLE_AUDIT?'enabled':'disabled'},
]; }
